<template>
    <div>
        <b-card title="DENT IMPORT 🚀">
            <b-card-text>Proyecto en desarrollo ...</b-card-text>
        </b-card>
    </div>
</template>

<script>

    import { BCard, BCardText, BLink } from 'bootstrap-vue';

    export default {
        components: {
            BCard,
            BCardText,
            BLink,
        }
    }

</script>
